import { render, staticRenderFns } from "./middleTable.vue?vue&type=template&id=18e465e4&scoped=true"
import script from "./middleTable.vue?vue&type=script&lang=js"
export * from "./middleTable.vue?vue&type=script&lang=js"
import style0 from "./middleTable.vue?vue&type=style&index=0&id=18e465e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e465e4",
  null
  
)

export default component.exports